{
  "version": 1,
  "asset_id": "727aa4b5-a822-40b4-bfc1-bc88a9fc2069",
  "project_id": "821317bb-5c16-42f2-91c7-33504f8f052a",
  "url": "/__l5e/assets-v1/727aa4b5-a822-40b4-bfc1-bc88a9fc2069/plan-dhamaka.png",
  "r2_key": "a/v1/821317bb-5c16-42f2-91c7-33504f8f052a/727aa4b5-a822-40b4-bfc1-bc88a9fc2069/plan-dhamaka.png",
  "original_filename": "plan-dhamaka.png",
  "size": 1786961,
  "content_type": "image/png",
  "created_at": "2026-06-26T14:56:52Z"
}
